import { LinkItem } from '@occc-app/design-system';

import { routeCreator } from '../../tobacco-api-offers.router';

export const buildTobaccoApiOfferDetailsBreadcrumbs = (label: string): LinkItem[] => [
  {
    label: 'Tobacco Offers',
    to: routeCreator.base(),
  },
  { label },
];
